import { uiActions } from '../ui-slice';
import { form7Actions } from './form7-slice';
import { formEndingActions } from './formEnding-slice';
import {
  doNavigation,
  logResponseFromAPI,
  verifyErrors,
} from '../../utils/helper-functions';
import { postEmissionDocuments } from '../../requests/emission';
import { postPayment } from '../../requests/payment';
import {
  POST_PAYMENT_URL,
  POST_EMISSION_DOCUMENTS_URL,
} from '../../constants/constants';

export const emitDocuments = (
  token,
  idProcess,
  emissionId,
  currentStep,
  navigateHook,
) => {
  return (dispatch) => {
    dispatch(uiActions.setProcessStatus({
      currentStep: 2,
      totalSteps: 2,
      humanMessage: 'Tus documentos se están emitiendo',
      image: 'loading',
    }));
    postEmissionDocuments(token, { emissionId }).then((response) => {
      const { data: { data } } = response;
      const urls = {};
      verifyErrors(response);

      data.forEach((item) => {
        urls[item.typeDocument] = item.path;
      });

      dispatch(formEndingActions.setUrls(urls));
      logResponseFromAPI(
        idProcess,
        'Policy retrival',
        response.status,
        'ok',
        POST_EMISSION_DOCUMENTS_URL,
      );
      dispatch(uiActions.clearProcessStatus());
      doNavigation(currentStep, 'forward', navigateHook, dispatch, true);
    }).catch((error) => {
      dispatch(uiActions.setProcessStatus({
        currentStep: 2,
        totalSteps: 2,
        humanMessage: 'Hubo un error al emitir tus documentos.',
        apiMessage: error.response?.message || error.message,
        image: 'error',
        buttonLabel: 'Inténtalo de nuevo',
        buttonIcon: 'reload',
        buttonIconPosition: 'before',
        buttonAction: () => {
          dispatch(emitDocuments(
            token,
            idProcess,
            emissionId,
            currentStep,
            navigateHook,
          ));
        },
      }));
      logResponseFromAPI(
        idProcess,
        'Policy retrival',
        error.response?.status || '5xx',
        `Soft error: ${error.message}`,
        POST_EMISSION_DOCUMENTS_URL,
      );
      throw error;
    });
  };
};

export const processPayment = (
  token,
  idProcess,
  emissionId,
  values,
  data,
  currentStep,
  navigateHook,
) => {
  return (dispatch) => {
    dispatch(uiActions.setProcessStatus({
      currentStep: 1,
      totalSteps: 2,
      humanMessage: 'Tu pago se está procesando',
      image: 'loading',
    }));

    postPayment(token, data.payment)
      .then((response) => {
        verifyErrors(response);

        dispatch(uiActions.setProcessStatus({
          currentStep: 1,
          totalSteps: 2,
          humanMessage: 'Pago exitoso',
          image: 'success',
        }));

        dispatch(form7Actions.setFormData(values));
        dispatch(form7Actions.setIsPaid({ isPaid: true }));
        dispatch(emitDocuments(
          token,
          idProcess,
          emissionId,
          currentStep,
          navigateHook,
        ));

        logResponseFromAPI(
          idProcess,
          'Payment',
          response.status,
          'ok',
          POST_PAYMENT_URL,
        );
      })
      .catch((error) => {
        dispatch(uiActions.setProcessStatus({
          currentStep: 1,
          totalSteps: 2,
          humanMessage: 'Hubo un error al procesar tu pago.',
          apiMessage: error.response?.message || error.message,
          image: 'error',
          buttonLabel: 'Regresar',
          buttonIcon: 'arrow-left',
          buttonIconPosition: 'before',
          buttonAction: () => {
            dispatch(uiActions.clearErrorStatus());
          },
        }));
        logResponseFromAPI(
          idProcess,
          'Payment',
          error.response?.status || '5xx',
          `Soft error: ${error.message}`,
          POST_PAYMENT_URL,
        );
        throw error;
      });
  };
};
